import { createAction } from '@reduxjs/toolkit';

export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';

export const setGlobalLoaderAction = createAction<boolean>(SET_GLOBAL_LOADER);
